import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import ContractTable from 'components/ui/tables/ContractTable';

const ContractsModal = (props) => {
  const { open, setOpen, data } = props;
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[75vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !mb-5 !bg-[#CDCDCDC7]'
      >
        <span className='mr-4'>{t('contract.title')}</span>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper h-[calc(100vh-180px)]'>
          <ContractTable
            emitRefetch={{ refetch: false, setRefetch: () => {} }}
            tableName='contract'
            actionInfo={false}
            noActions
            data={data}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ContractsModal);
